import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import { DialogLeadTimeOption, DialogPhase } from '../../../core/models/dialog/dialog'
import type { CoachingStatus } from '@/modules/dashboard/composables/useCoachingInvitations'
import type { CoachSurveyRecurrenceSettings } from '@/modules/coach-surveys/composables/use-coach-survey'
import type { SurveyState } from '@/modules/survey/models/survey-state'
import type { Objective } from '@/core/composables/use-objectives'
import type { Member } from '@/core/models/member/member'

export const useCurrentDialogs = () => {
  const { data, load, status } = useGet<{ coachingRelations: ReadonlyArray<MyCoachingRelation> }>(
    `dialog`,
  )

  onMounted(() => {
    load()
  })

  return { status, data }
}

export interface MyCoachingRelation {
  readonly coach: Member
  readonly status: CoachingStatus
  readonly latestDialog?: MyCoachingDialog
  readonly currentObjectives: ReadonlyArray<Objective>
  readonly feedbackGoals: ReadonlyArray<MyCoachingFeedbackGoal>
  readonly coacheeSurveys: ReadonlyArray<MyCoachingSurvey>
}

interface MyCoachingDialog {
  readonly id: string
  readonly phase: DialogPhase
  readonly createdAt: string
  readonly plannedAt?: string
  readonly coacheeDataReleasedAt?: string
  readonly coachDataReleasedAt?: string
  readonly conductedAt?: string
  readonly leadTimeStartsAt?: string
  readonly leadTimeOption?: DialogLeadTimeOption
}

interface MyCoachingFeedbackGoal {
  readonly id: string
  readonly feedbackTopic: { id: string; title: string; icon?: string }
  readonly isActive: boolean
  readonly lastDialogConductedAt: string | null
  readonly progress: ReadonlyArray<{
    readonly perspectiveKey: string
    readonly count: number
    readonly target: number
  }>
}

interface MyCoachingSurvey {
  readonly id: string
  readonly title?: string
  readonly createdAt: string
  readonly feedbackTopic: { id: string; title: string; icon?: string }
  readonly recurrence?: CoachSurveyRecurrenceSettings
  readonly occurrences: ReadonlyArray<{
    readonly id: string
    readonly state: SurveyState
    readonly startDate: string
    readonly hasAnswered: boolean
  }>
}
